__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.54.17-2c62-amber-user-website-prod-hk-1872/assets/";